import React from 'react';

/**
 * TabPanel component for handling tab content display
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The content to display when the tab is active
 * @param {number} props.value - The current tab value
 * @param {number} props.index - The index of this tab panel
 * @returns {JSX.Element|null} The tab panel content if active, or null
 */
export default function TabPanel({ children, value, index }) {
  return value === index ? children : null;
}
